import React from "react";
import DialogSearch from "../DialogSearch";
import TileProductType from "../../Tile/TileProductType";
import PropTypes from "prop-types";
import ProductType from "../../../Utility/Crud/ProductType";
import MainContext from "../../../Context/MainContext/MainContext";

export default class DialogSearchProductType extends DialogSearch {
  static contextType = MainContext; // For legacy class components

  /**
   * Searches for dpartments by several name combinations or ID.
   *
   * @param {string} query The search query.
   * @returns A list of filtered productType.
   */
  getSearchResults(query) {
    return ProductType.search(this.state.data, query, true);
  }

  /**
   * Gets the data that should be used in this dialog. Data can be manually
   * passed via the data prop, otherwise it falls back to the global list.
   *
   * @returns {array}
   */
  getData() {
    if (this.props.data) {
      return this.props.data;
    } else {
      return Object.values(this.context.productTypesIndexed);
    }
  }

  /**
   * @param {object} productType The productType object.
   * @returns A TileProductType component for this productType.
   */
  renderTile(productType) {
    return <TileProductType key={productType.id} productType={productType} />;
  }
}
